module.exports = __webpack_public_path__ + "img/board.74b7e738.png";